/* AURALIGN — custom cart drawer (CQ-014)
 * Native AJAX line updates + Section Rendering API refresh.
 * Loaded deferred from layout/theme.liquid after window.routes. */

(function () {
  'use strict';

  /* GA4 / dataLayer push helper. Mirror of the PDP file's pushDL — kept local
     so the cart drawer JS has no cross-file dependencies. Safe no-op if no
     tag manager is installed. Standard events: cart_open, cart_upsell_added,
     bundle_tier_unlocked, checkout_started. */
  function pushDL(event, payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: event, source: 'global_cart' }, payload || {}));
    } catch (e) {}
  }

  /**
   * @param {HTMLElement} section
   */
  function mountCartDrawer(section) {
    if (!section || section.__auralignCartMounted) return;
    section.__auralignCartMounted = true;

    var panel = section.querySelector('.cart-drawer__panel');
    var body = section.querySelector('[data-cart-body]');
    var footer = section.querySelector('[data-cart-footer]');
    var countEl = section.querySelector('[data-cart-count]');
    var sectionId =
      section.getAttribute('data-cart-section-api-id') || 'custom-cart-drawer';
    var freeShipThreshold = parseInt(
      section.getAttribute('data-free-ship-threshold') || '0',
      10
    );

    var teardown = [];
    function on(target, event, handler, opts) {
      target.addEventListener(event, handler, opts);
      teardown.push(function () {
        target.removeEventListener(event, handler, opts);
      });
    }

    var FOCUSABLE =
      'a[href]:not([tabindex="-1"]), button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function trapTab(e) {
      if (e.key !== 'Tab') return;
      var nodes = panel.querySelectorAll(FOCUSABLE);
      if (!nodes.length) return;
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    var lastFocused = null;
    var isOpen = false;

    function setBackgroundInert(enable) {
      var drawerRoot = section;
      var nodes = document.querySelectorAll(
        'main, .shopify-section-header, .shopify-section-group-header-group, footer, .custom-footer-section'
      );
      Array.prototype.forEach.call(nodes, function (el) {
        if (!el || !el.nodeType) return;
        if (drawerRoot.contains(el)) return;
        if (el.contains && el.contains(drawerRoot)) return;
        if (enable) el.setAttribute('inert', '');
        else el.removeAttribute('inert');
      });
    }

    function openDrawer() {
      if (isOpen) return;
      isOpen = true;
      lastFocused = document.activeElement;
      section.setAttribute('aria-hidden', 'false');
      setBackgroundInert(true);
      if (window.BettrMetrics) window.BettrMetrics.mark('cart-drawer-open');
      /* Read cart from the rendered section to keep payload shape parity with
         the PDP cart drawer (cart_qty, cart_unique, cart_value). */
      var bar = section.querySelector('[data-bundle-bar]');
      var subtotalEl = section.querySelector('[data-cart-subtotal]');
      var countEl2 = section.querySelector('[data-cart-count]');
      var cartQty = countEl2 ? parseInt(countEl2.textContent, 10) || 0 : 0;
      var bundleTier = bar ? parseInt(bar.getAttribute('data-bundle-tier'), 10) || 0 : 0;
      var cartValue = 0;
      if (subtotalEl) {
        var v = parseFloat((subtotalEl.textContent || '').replace(/[^0-9.]/g, ''));
        if (!isNaN(v)) cartValue = v;
      }
      pushDL('cart_open', { cart_qty: cartQty, bundle_tier: bundleTier, cart_value: cartValue });
      window.requestAnimationFrame(function () {
        var firstFocus = panel.querySelector('.cart-drawer__close');
        if (firstFocus) firstFocus.focus();
      });
    }

    function closeDrawer() {
      if (!isOpen) return;
      isOpen = false;
      section.setAttribute('aria-hidden', 'true');
      setBackgroundInert(false);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        try {
          lastFocused.focus();
        } catch (err) {}
      }
    }

    on(section, 'click', function (e) {
      if (e.target.closest('[data-cart-close]')) {
        e.preventDefault();
        closeDrawer();
      }
    });

    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && isOpen) closeDrawer();
      else if (isOpen) trapTab(e);
    });

    on(document, 'cart:open', openDrawer);

    on(document, 'cart:item-added', function () {
      if (
        'vibrate' in navigator &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        try {
          navigator.vibrate(10);
        } catch (err) {}
      }
      /* Open FIRST, then refresh in place (2026-08-16). The old
         refreshDrawer().then(openDrawer) held the drawer shut until a full
         Section Rendering fetch of the heavy PDP route completed (seconds of
         apparent dead click), and every queued add scheduled another open at
         its own fetch-completion — so the drawer would pop open again 5–10s
         after the shopper had already closed it. Opening synchronously means
         the drawer appears instantly with the current markup;
         fastSubtotalSync() corrects the numbers within ~100ms and the section
         refresh swaps the body when it lands. A refresh that resolves after
         the shopper closed the drawer now updates content silently instead of
         re-opening it. */
      openDrawer();
      refreshDrawer();
    });

    on(document, 'click', function (e) {
      var trigger = e.target.closest(
        '.custom-header__cart-link, [data-cart-drawer-open]'
      );
      if (!trigger) return;
      e.preventDefault();
      openDrawer();
    });

    on(document, 'keydown', function (e) {
      if (e.code !== 'Space' && e.key !== ' ') return;
      var link =
        e.target && e.target.closest
          ? e.target.closest('.custom-header__cart-link')
          : null;
      if (!link || document.activeElement !== link) return;
      e.preventDefault();
      openDrawer();
    });

    on(panel, 'click', function (e) {
      var btn = e.target.closest('[data-qty-action]');
      if (!btn) return;
      e.preventDefault();
      var item = btn.closest('[data-item-key]');
      if (!item) return;
      var key = item.getAttribute('data-item-key');
      var action = btn.getAttribute('data-qty-action');
      var qtyValue = item.querySelector('[data-qty-value]');
      var current = parseInt(qtyValue.textContent, 10) || 0;
      var newQty;
      if (action === 'remove') newQty = 0;
      else if (action === 'increase') newQty = current + 1;
      else if (action === 'decrease') newQty = Math.max(0, current - 1);
      else return;

      if (newQty > 0) {
        qtyValue.textContent = newQty;

        var leftBtn = item.querySelector(
          '.cart-drawer__qty-btn--remove, .cart-drawer__qty-btn--decrease'
        );
        if (leftBtn) {
          var shouldBeDecrease = newQty > 1;
          var isDecrease = leftBtn.classList.contains(
            'cart-drawer__qty-btn--decrease'
          );
          if (shouldBeDecrease !== isDecrease) {
            var svg;
            if (shouldBeDecrease) {
              leftBtn.className =
                'cart-drawer__qty-btn cart-drawer__qty-btn--decrease';
              leftBtn.setAttribute('data-qty-action', 'decrease');
              leftBtn.setAttribute('aria-label', 'Decrease quantity');
              svg =
                '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 12H19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
            } else {
              leftBtn.className =
                'cart-drawer__qty-btn cart-drawer__qty-btn--remove';
              leftBtn.setAttribute('data-qty-action', 'remove');
              leftBtn.setAttribute('aria-label', 'Remove from cart');
              svg =
                '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.76256 2.76256C9.09075 2.43437 9.53587 2.25 10 2.25H14C14.4641 2.25 14.9092 2.43437 15.2374 2.76256C15.5656 3.09075 15.75 3.53587 15.75 4V6.25H20C20.4142 6.25 20.75 6.58579 20.75 7C20.75 7.41421 20.4142 7.75 20 7.75H19.6984L18.8811 19.1952C18.8317 19.889 18.5212 20.5384 18.0123 21.0124C17.5033 21.4865 16.8335 21.75 16.138 21.75H7.86202C7.16646 21.75 6.49673 21.4865 5.98773 21.0124C5.47878 20.5384 5.16833 19.8892 5.1189 19.1954L4.30164 7.75H4C3.58579 7.75 3.25 7.41421 3.25 7C3.25 6.58579 3.58579 6.25 4 6.25H8.25V4C8.25 3.53587 8.43437 3.09075 8.76256 2.76256ZM9.75 6.25H14.25V4C14.25 3.9337 14.2237 3.87011 14.1768 3.82322C14.1299 3.77634 14.0663 3.75 14 3.75H10C9.9337 3.75 9.87011 3.77634 9.82322 3.82322C9.77634 3.87011 9.75 3.9337 9.75 4V6.25ZM5.80546 7.75L6.6151 19.0886C6.63754 19.4039 6.77867 19.6993 7.01004 19.9147C7.2414 20.1302 7.54582 20.25 7.862 20.25H16.138C16.4542 20.25 16.7586 20.1302 16.99 19.9147C17.2213 19.6993 17.3624 19.4041 17.3849 19.0888L18.1945 7.75H5.80546ZM10 10.25C10.4142 10.25 10.75 10.5858 10.75 11V17C10.75 17.4142 10.4142 17.75 10 17.75C9.58579 17.75 9.25 17.4142 9.25 17V11C9.25 10.5858 9.58579 10.25 10 10.25ZM14 10.25C14.4142 10.25 14.75 10.5858 14.75 11V17C14.75 17.4142 14.4142 17.75 14 17.75C13.5858 17.75 13.25 17.4142 13.25 17V11C13.25 10.5858 13.5858 10.25 14 10.25Z" fill="currentColor"/></svg>';
            }
            leftBtn.innerHTML = svg;
          }
        }
      } else {
        item.classList.add('is-loading');
      }

      var linePriceEl = item.querySelector('.cart-drawer__item-price');
      var subtotalEl = section.querySelector('[data-cart-subtotal]');
      var affirmEl = section.querySelector('[data-cart-affirm-amount]');
      if (newQty > 0) {
        if (linePriceEl) linePriceEl.classList.add('bettr-skeleton');
        if (subtotalEl) subtotalEl.classList.add('bettr-skeleton');
        if (affirmEl) affirmEl.classList.add('bettr-skeleton');
      } else {
        if (subtotalEl) subtotalEl.classList.add('bettr-skeleton');
        if (affirmEl) affirmEl.classList.add('bettr-skeleton');
      }

      var clearSkeletons = function () {
        if (linePriceEl) linePriceEl.classList.remove('bettr-skeleton');
        if (subtotalEl) subtotalEl.classList.remove('bettr-skeleton');
        if (affirmEl) affirmEl.classList.remove('bettr-skeleton');
      };
      changeLineItem(key, newQty)
        .then(function (ok) {
          if (ok) {
            refreshDrawer();
          } else {
            qtyValue.textContent = current;
            item.classList.remove('is-loading');
            clearSkeletons();
          }
        })
        .catch(function () {
          qtyValue.textContent = current;
          item.classList.remove('is-loading');
          clearSkeletons();
        });
    });

    /* ───── Bundle upsell ("Complete the set") + tier-up celebration ─────
       The Liquid in custom-cart-drawer.liquid renders the upsell cards and
       bundle progress bar server-side on every Section Rendering refresh.
       This JS adds: add-to-cart click handler for the upsell cards, and a
       one-shot pulse + toast when the customer crosses into a higher tier. */
    var lastBundleTier = -1;

    function readBundleTier() {
      var bar = section.querySelector('[data-bundle-bar]');
      if (!bar) return 0;
      var t = parseInt(bar.getAttribute('data-bundle-tier'), 10);
      return isNaN(t) ? 0 : t;
    }

    function maybeCelebrateTierUp() {
      var pct = readBundleTier();
      if (lastBundleTier === -1) {
        lastBundleTier = pct;
        return;
      }
      if (pct > lastBundleTier) {
        lastBundleTier = pct;
        /* Fire analytics + toast synchronously so they don't depend on RAF
           (throttled when the tab isn't visible). */
        pushDL('bundle_tier_unlocked', { tier_pct: pct });
        cartToast('Bundle ' + pct + '% off unlocked');
        if (
          'vibrate' in navigator &&
          !window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ) {
          try { navigator.vibrate(15); } catch (e) {}
        }
        var fill = section.querySelector('[data-bundle-fill]');
        if (fill) {
          fill.classList.remove('is-celebrating');
          void fill.offsetWidth; /* force reflow so animation restarts */
          fill.classList.add('is-celebrating');
          setTimeout(function () {
            fill.classList.remove('is-celebrating');
          }, 1200);
        }
      } else {
        lastBundleTier = pct;
      }
    }

    /* Tiny ephemeral toast — used only by the bundle celebration. The PDP
       cart drawer has its own toast wired to #toast; here we lazy-create a
       node so we don't bloat the cart-drawer Liquid with markup that only
       fires occasionally. */
    function cartToast(msg) {
      var t = document.getElementById('cartDrawerToast');
      if (!t) {
        t = document.createElement('div');
        t.id = 'cartDrawerToast';
        t.setAttribute('role', 'status');
        t.setAttribute('aria-live', 'polite');
        t.style.cssText =
          'position:fixed;bottom:28px;left:50%;transform:translateX(-50%) translateY(140px);' +
          'background:#171411;color:#fffdf8;padding:12px 22px;border-radius:8px;font-size:13px;' +
          'letter-spacing:.02em;z-index:1000;box-shadow:0 14px 32px rgba(23,20,17,.18);' +
          'transition:transform .4s cubic-bezier(.22,.61,.36,1);pointer-events:none;font-family:Neue Montreal,system-ui,sans-serif';
        document.body.appendChild(t);
      }
      t.textContent = msg;
      requestAnimationFrame(function () {
        t.style.transform = 'translateX(-50%) translateY(0)';
      });
      clearTimeout(t.__hide);
      t.__hide = setTimeout(function () {
        t.style.transform = 'translateX(-50%) translateY(140px)';
      }, 2400);
    }

    /* Checkout submit — fire dataLayer event so we can measure cart-to-checkout */
    on(panel, 'submit', function (e) {
      var form = e.target.closest('.cart-drawer__checkout-form');
      if (!form) return;
      var bar = section.querySelector('[data-bundle-bar]');
      var tier = bar ? parseInt(bar.getAttribute('data-bundle-tier'), 10) : 0;
      pushDL('checkout_started', { bundle_tier: isNaN(tier) ? 0 : tier });
    });

    /* Bundle add buttons — delegate so we don't re-bind on each refresh */
    on(panel, 'click', function (e) {
      var btn = e.target.closest('[data-bundle-add]');
      if (!btn) return;
      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      var title = btn.getAttribute('data-product-title') || 'Item';
      if (!variantId) return;
      var lastLine = section.querySelector('[data-line-finish]');
      var lineFinish = lastLine ? lastLine.getAttribute('data-line-finish') : '';
      if (lineFinish) {
        try {
          var vmap = JSON.parse(btn.getAttribute('data-variant-map') || '{}');
          if (vmap[lineFinish]) variantId = String(vmap[lineFinish]);
        } catch (mapErr) {}
      }
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = '…';
      pushDL('cart_upsell_added', { variant_id: variantId, product_title: title });
      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (d) { throw d; });
          return r.json();
        })
        .then(function () {
          return refreshDrawer();
        })
        .catch(function (err) {
          btn.disabled = false;
          btn.textContent = originalText;
          var msg = (err && err.description) || 'Could not add — please try again';
          cartToast(msg);
        });
    });

    function changeLineItem(key, quantity) {
      document.documentElement.classList.add('is-busy');
      var clearBusy = function () {
        document.documentElement.classList.remove('is-busy');
      };
      var doFetch = function () {
        return fetch(window.routes.cart_change_url + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ id: key, quantity: quantity }),
        }).then(
          function (r) {
            clearBusy();
            return r.ok;
          },
          function (err) {
            clearBusy();
            throw err;
          }
        );
      };
      if (
        window.BettrCrossTab &&
        typeof window.BettrCrossTab.withLock === 'function'
      ) {
        return window.BettrCrossTab.withLock('bettr-cart-mutation', doFetch);
      }
      return doFetch();
    }

    function formatMoney(cents) {
      if (typeof cents !== 'number') return '';
      var n = Math.round(cents) / 100;
      var parts = n.toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (parts[1] === '00') return '$' + parts[0];
      return '$' + parts.join('.');
    }

    function updateFreeShipProgress(cart) {
      var wrap = section.querySelector('[data-free-ship-progress]');
      if (!wrap || freeShipThreshold <= 0) return;
      var fill = wrap.querySelector('[data-free-ship-fill]');
      var label = wrap.querySelector('[data-free-ship-label]');
      if (!fill) return;
      var total = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
      var remaining = Math.max(0, freeShipThreshold - total);
      var pct = Math.min(100, Math.round((total / freeShipThreshold) * 100));
      fill.style.width = pct + '%';
      if (label) {
        if (remaining <= 0) {
          label.textContent = wrap.getAttribute('data-msg-unlocked') || 'Unlocked';
        } else {
          var template =
            wrap.getAttribute('data-msg-remaining') ||
            'Add %amount% more for free shipping';
          label.textContent = template.replace(
            '%amount%',
            formatMoney(remaining)
          );
        }
      }
      var shipRow = section.querySelector('[data-ship-row]');
      if (shipRow) {
        if (remaining <= 0) shipRow.removeAttribute('hidden');
        else shipRow.setAttribute('hidden', '');
      }
    }

    var subtotalAbort = null;
    var refreshAbort = null;

    function fastSubtotalSync() {
      if (subtotalAbort) subtotalAbort.abort();
      subtotalAbort = new AbortController();
      return fetch(window.routes.cart_url + '.js', {
        headers: { Accept: 'application/json' },
        signal: subtotalAbort.signal,
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          var subtotalEl = section.querySelector('[data-cart-subtotal]');
          if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
          if (countEl) countEl.textContent = cart.item_count;
          updateFreeShipProgress(cart);
          var headerBadge = document.querySelector('.custom-header__cart-count');
          if (headerBadge) {
            if (cart.item_count > 0) {
              headerBadge.textContent = cart.item_count;
              headerBadge.style.display = '';
            } else {
              headerBadge.style.display = 'none';
            }
          } else if (cart.item_count > 0) {
            var cartLink = document.querySelector('.custom-header__cart-link');
            if (cartLink) {
              var span = document.createElement('span');
              span.className = 'custom-header__cart-count';
              span.textContent = cart.item_count;
              cartLink.appendChild(span);
            }
          }
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
        });
    }

    function refreshDrawer() {
      fastSubtotalSync();

      if (refreshAbort) refreshAbort.abort();
      refreshAbort = new AbortController();

      var url =
        window.location.pathname +
        '?sections=' +
        encodeURIComponent(sectionId) +
        '&t=' +
        Date.now();
      return fetch(url, { signal: refreshAbort.signal })
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          var html = data[sectionId];
          if (!html) return;
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newBody = doc.querySelector('[data-cart-body]');
          var newFooter = doc.querySelector('[data-cart-footer]');
          var newCount = doc.querySelector('[data-cart-count]');

          if (newBody && body) body.innerHTML = newBody.innerHTML;
          if (newFooter && footer) {
            footer.innerHTML = newFooter.innerHTML;
            if (newFooter.hasAttribute('hidden')) footer.setAttribute('hidden', '');
            else footer.removeAttribute('hidden');
          }
          if (newCount && countEl) countEl.textContent = newCount.textContent;

          maybeCelebrateTierUp();

          document.dispatchEvent(new CustomEvent('cart:updated'));

          var headerBadge = document.querySelector('.custom-header__cart-count');
          if (newCount) {
            var n = parseInt(newCount.textContent, 10) || 0;
            if (headerBadge) {
              if (n > 0) {
                headerBadge.textContent = n;
                headerBadge.style.display = '';
              } else {
                headerBadge.style.display = 'none';
              }
            } else if (n > 0) {
              var cartLink = document.querySelector('.custom-header__cart-link');
              if (cartLink) {
                var span = document.createElement('span');
                span.className = 'custom-header__cart-count';
                span.textContent = n;
                cartLink.appendChild(span);
              }
            }
          }
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
        });
    }

    on(document, 'cart:cleaned', function () {
      refreshDrawer();
    });

    on(document, 'cart:updated', function (ev) {
      if (ev && ev.detail && ev.detail.__fromBroadcast) {
        refreshDrawer();
      }
    });

    function onUnload(e) {
      if (!section || !e.target || !e.target.contains(section)) return;
      if (isOpen) closeDrawer();
      if (subtotalAbort) {
        try {
          subtotalAbort.abort();
        } catch (err) {}
      }
      if (refreshAbort) {
        try {
          refreshAbort.abort();
        } catch (err) {}
      }
      teardown.forEach(function (fn) {
        try {
          fn();
        } catch (err) {}
      });
      teardown.length = 0;
      section.__auralignCartMounted = false;
      document.removeEventListener('shopify:section:unload', onUnload);
    }
    document.addEventListener('shopify:section:unload', onUnload);
  }

  function boot(ev) {
    var root = ev && ev.target && ev.target.querySelector;
    var section = root
      ? ev.target.querySelector('[data-cart-drawer]')
      : null;
    if (!section) section = document.querySelector('[data-cart-drawer]');
    mountCartDrawer(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('[data-cart-drawer]')) boot(e);
  });
})();
